import { render, staticRenderFns } from "./certificateDet.vue?vue&type=template&id=eb181272&scoped=true&"
import script from "./certificateDet.vue?vue&type=script&lang=js&"
export * from "./certificateDet.vue?vue&type=script&lang=js&"
import style0 from "./certificateDet.vue?vue&type=style&index=0&id=eb181272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb181272",
  null
  
)

export default component.exports